import { createAction, props } from '@ngrx/store';
export const setChartId = createAction('[Tech Chart] Set Chart Id', props());
